import {
  ID,
  NewTodo,
  TaskActionType,
  TaskType,
  Timeslot,
  TimeslotTaskLink,
  Timestamp,
} from '@griply/types';
import { endOfDay } from 'date-fns';

export type TimeslotTaskWrite = {
  task: NewTodo;
  tags: ID[] | undefined;
};

// A tag timeslot also tags the task (same write batch); goal/life-area link via their own column; smart-list is action-only.
export const buildTimeslotTask = (
  link: TimeslotTaskLink,
  eventDate: Timestamp,
  timeslot: Timeslot | null,
): TimeslotTaskWrite => {
  const { id, name, actionType } = link;
  return {
    task: {
      type: TaskType.Task,
      schedules: null,
      endStrategy: {
        deadline: endOfDay(eventDate),
        completionCount: null,
      },
      createdAt: new Date(),
      goalId: actionType === TaskActionType.GoalTimeslot ? id : null,
      lifeAreaId: actionType === TaskActionType.LifeAreaTimeslot ? id : null,
      name,
      reminderTime: null,
      startDate: null,
      parentIds: null,
      priority: null,
      hideOnTodo: null,
      timeslot,
      action: { type: actionType, meta: { id } },
    },
    tags: actionType === TaskActionType.TagTimeslot ? [id] : undefined,
  };
};
